"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
require("./AdminCategoryData.scss");
var _CategoryTranslationData = _interopRequireDefault(require("./CategoryTranslationData"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const AdminCategoryData = _ref => {
  let {
    content,
    currentLanguageURL
  } = _ref;
  const {
    name,
    industry,
    url,
    languageOptions,
    translations,
    Link
  } = content;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "luna-admin-category-data"
  }, name && /*#__PURE__*/_react.default.createElement("h4", {
    className: "luna-admin-category-data__name"
  }, name), industry && /*#__PURE__*/_react.default.createElement("p", {
    className: "luna-admin-category-data__industry"
  }, /*#__PURE__*/_react.default.createElement("span", null, "Industry:"), " ", industry), translations && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, translations.map((translation, index) => {
    return /*#__PURE__*/_react.default.createElement(_CategoryTranslationData.default, {
      key: translation.name + index,
      content: translation,
      url: url,
      currentLanguageURL: currentLanguageURL,
      languageOptions: languageOptions
    });
  })));
};
var _default = AdminCategoryData;
exports.default = _default;